import { Button } from 'primereact/button';
import { useEffect, useState } from 'react';
import { useAccountContext } from '../../../../contexts/AccountContext';
import { privateFetch } from '../../../../utils/apiHelper';
import { getImage } from '../../../../utils/imageHelper';
import { FileUpload } from 'primereact/fileupload';

function ImageItem({
  image,
  alt,
  className = '',
  deleteImage,
  imageLoad,
  showLabel = false,
  showPlaceholder = false,
  updateImage,
  fileUploadRef
}) {
  const [currentImage, setCurrentImage] = useState(image);
  const [imageIsProcessing, setImageIsProcessing] = useState(
    image?.processing_status === 'processing' || image?.processing_status === 'pending'
  );

  const { accountContext } = useAccountContext();

  useEffect(() => {
    const getImageDetails = async () => {
      const res = await privateFetch(
        'GET',
        'resources',
        `/cu/${accountContext.id}/image/${image.id}/`
      );

      if (!res) return;

      setCurrentImage(res);

      const stillProcessing =
        res.processing_status === 'pending' || res.processing_status === 'processing';

      setImageIsProcessing(stillProcessing);

      return stillProcessing;
    };

    let interval;
    const shouldPoll =
      image?.processing_status === 'pending' || image?.processing_status === 'processing';
    if (shouldPoll) {
      getImageDetails();
      interval = setInterval(async () => {
        const stillProcessing = await getImageDetails();
        if (!stillProcessing) {
          clearInterval(interval);
        }
      }, 1000);
    }
    return () => {
      if (interval) clearInterval(interval);
    };
  }, [image?.id, image?.processing_status, accountContext.id]);

  if (!currentImage)
    return showPlaceholder ? (
      <img src={getImage('img-ph.png')} alt={alt} className={className} />
    ) : null;

  return (
    <div key={currentImage.id} className={`flex flex-col gap-y-1 relative ${className}`}>
      <img
        src={currentImage.file || getImage('img-ph.png')}
        className={`object-cover w-auto h-full ${imageIsProcessing ? 'opacity-80' : ''}`}
        alt={alt}
        onLoad={imageLoad ? imageLoad : undefined}
      />

      {imageIsProcessing && (
        <div className="absolute top-3 left-3">
          <div className="flex flex-row gap-x-2 items-center bg-slate-50 rounded-full pl-2 pr-3 py-1">
            <i className="pi pi-spin pi-spinner" />
            <span>Compression</span>
          </div>
        </div>
      )}

      {currentImage.processing_status === 'ready' && (
        <div className="absolute top-3 left-3">
          <div className="flex flex-row gap-x-2 items-center bg-green-700 rounded-full text-slate-50 font-medium pl-2 pr-3 py-1">
            <i className="pi pi-sparkles" />
            <span>Compressée</span>
          </div>
        </div>
      )}

      {deleteImage && (
        <Button
          icon="pi pi-trash"
          rounded
          raised
          text
          className="absolute top-3 right-3 text-xs bg-white"
          severity="danger"
          aria-label="Supprimer l'image"
          onClick={deleteImage}
        />
      )}
      {updateImage && (
        <div className="update-fileupload">
          <FileUpload
            ref={fileUploadRef}
            className="absolute top-14 right-3"
            mode="basic"
            title="Valider"
            accept="image/*"
            customUpload
            uploadHandler={updateImage}
            chooseLabel="Changer l'image"
            rounded
            auto
            chooseOptions={{
              icon: 'pi pi-pencil'
            }}
          />
        </div>
      )}

      {currentImage.label && showLabel && (
        <span className="text-slate-600 text-sm pl-1 h-6">{currentImage.label}</span>
      )}

      {currentImage.processing_status === 'failed' && (
        <span className="text-red-500 text-xs pl-1">Erreur pendant l’optimisation</span>
      )}
    </div>
  );
}

export default ImageItem;
